import styled from 'styled-components';
import App from './App';

const AppStyled = styled(App)`
  height: 100%;
  width: 100%;
`;

export default AppStyled;
